var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "draggable",
        {
          staticClass: "drag-list",
          attrs: { group: "drag", animation: "300", move: _vm.onMove },
          on: { update: _vm.onUpdate },
          model: {
            value: _vm.sortList,
            callback: function ($$v) {
              _vm.sortList = $$v
            },
            expression: "sortList",
          },
        },
        [
          _c(
            "transition-group",
            { staticClass: "draggable-group" },
            _vm._l(_vm.sortList, function (item) {
              return _c(
                "span",
                {
                  key: item,
                  staticClass: "item-dimension",
                  attrs: { title: item },
                },
                [
                  _c("svg-icon", {
                    staticClass: "item-icon",
                    attrs: { "icon-class": "drag" },
                  }),
                  _c("span", { staticClass: "item-span" }, [
                    _vm._v("\n          " + _vm._s(item) + "\n        "),
                  ]),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }